import { render, staticRenderFns } from "./GlobalConfigPage.vue?vue&type=template&id=51d7824a&"
import script from "./GlobalConfigPage.vue?vue&type=script&lang=js&"
export * from "./GlobalConfigPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d7824a')) {
      api.createRecord('51d7824a', component.options)
    } else {
      api.reload('51d7824a', component.options)
    }
    module.hot.accept("./GlobalConfigPage.vue?vue&type=template&id=51d7824a&", function () {
      api.rerender('51d7824a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/globalConfig/GlobalConfigPage.vue"
export default component.exports